module.exports = __webpack_public_path__ + "img/xls.1bde934.png";